export default {
  setEquipmentTypes(state, value) {
    state.equipmentTypes = value
  },
  updateEquipmentTypes(state, value) {
    state.equipmentTypes = state.equipmentTypes.concat(value)
  },
  setEquipmentType(state, value) {
    state.equipmentType = value
  },
  prependEquipmentTypes(state, value) {
    state.equipmentTypes.unshift(value)
  },
  setEquipmentTypeField(state, obj) {
    if (state.equipmentType) {
      state.equipmentType = { ...state.equipmentType, ...obj }
    }
  },
  removeEquipmentTypePlace(state, obj) {
    if (state.equipmentType) {
      for (let i = 0; i < state.equipmentType.places.length; i++) {
        if (state.equipmentType.places[i].id === obj.id) {
          state.equipmentType.places.splice(i, 1)
          break
        }
      }
    }
  },
  changeEquipmentType(state, obj) {
    for (let i = 0; i < state.equipmentTypes.length; i++) {
      if (state.equipmentTypes[i].id === obj.id) {
        const item = _.cloneDeep(obj)
        state.equipmentTypes.splice(i, 1, item)
        break
      }
    }
  },
  deleteEquipmentType(state, id) {
    for (let i = 0; i < state.equipmentTypes.length; i++) {
      if (state.equipmentTypes[i].id === id) {
        state.equipmentTypes.splice(i, 1)
        break
      }
    }
  },
  setEquipmentTypeFilters(state, payload) {
    state.equipmentTypeFilters = payload
  },
}
